module.exports = __webpack_public_path__ + "img/pets.88e1e380.svg";